import { render, staticRenderFns } from "./ContentFullIWidthImageBlock.vue?vue&type=template&id=b6e1e584&scoped=true"
import script from "./ContentFullIWidthImageBlock.vue?vue&type=script&lang=js"
export * from "./ContentFullIWidthImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentFullIWidthImageBlock.vue?vue&type=style&index=0&id=b6e1e584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1e584",
  null
  
)

export default component.exports